import { useState } from "react";
import { axionsInstanceAdminApi, axionsInstanceBaseApi, axiosInstance } from ".";
import { start } from "repl";

export const useUserCount = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<any>();
  const fetchUserCount = async (token: string) => {
    setLoading(true);
    try {
      const response = await axiosInstance.post(
        "/statistic/new_user_count",
        {
          start:Date.now()-604800000,
          end:Date.now()
        },
        {
          headers: { "Content-Type": "application/json", Token: token },
        }
      );
      console.log("user response", response.data?.data);
      setData(response.data?.data)
      // setData({ ...data, list: response?.data?.data?.groups, totalCount: response?.data?.data?.total });
      setLoading(false);
    } catch (e) {
      setLoading(false);
      console.log("ERROR:::::::::", e);
    }
  };
  return [loading, fetchUserCount, data];
};


export const useLoginUserCount = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<any>();
  const fetchUserCount = async (token: string) => {
    setLoading(true);
    try {
      const response = await axiosInstance.post(
        "/statistic/login_user_count",
        {
          start:Date.now()-604800000,
          end:Date.now()
        },
        {
          headers: { "Content-Type": "application/json", Token: token },
        }
      );      
      setData(response.data?.data)
      // setData({ ...data, list: response?.data?.data?.groups, totalCount: response?.data?.data?.total });
      setLoading(false);
    } catch (e) {
      setLoading(false);
      console.log("ERROR:::::::::", e);
    }
  };
  return [loading, fetchUserCount, data];
};
